<div class="progress">
  <div class="progress-bar">
    <div class="progress-inner" [style.width.%]="currentLevel == maxLevel ? 100 : vipProgress"></div>
  </div>
  <div class="progress-info" [class.is-left-menu]="isLeftMenu">
    @if (!isLeftMenu) {
      @if (currentLevel !== null && currentLevel < maxLevel) {
        <p>Level {{ currentLevel + 1 }}</p>
      } @else {
        <p>Level {{ maxLevel }}</p>
      }
    }

    @if (currentLevel == maxLevel) {
      <p>You have reached max level</p>
    } @else {
      <p>{{ nextLevelPoint }} to level up</p>
    }

    @if (!isLeftMenu) {
      <p>
        @if (currentLevel !== null && currentLevel < maxLevel) {
          Level {{ currentLevel + 2 }}
        } @else {
          Level {{ maxLevel + 1 }}
        }
      </p>
    }
  </div>
</div>
